var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "notif-icon-svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51099 2.94706C7.94383 2.95578 6.44432 3.58671 5.34234 4.70103C4.24036 5.81536 3.62618 7.3218 3.63491 8.88897L3.67744 16.5252L15.4954 16.4594L15.4529 8.82314C15.4442 7.25598 14.8133 5.75647 13.6989 4.65449C12.5846 3.55251 11.0782 2.93833 9.51099 2.94706ZM17.4954 16.4482L17.4529 8.812C17.4412 6.71441 16.5967 4.70738 15.1052 3.23242C13.6138 1.75746 11.5974 0.935403 9.49985 0.947086C7.40226 0.95877 5.39523 1.80324 3.92027 3.29472C2.44531 4.7862 1.62325 6.80252 1.63494 8.90011L1.67747 16.5364L0.0865864 16.5452L0.0977262 18.5452L6.00931 18.5123C6.04862 19.4149 6.42707 20.2715 7.07185 20.9092C7.74901 21.5788 8.66447 21.9521 9.61682 21.9468C10.5692 21.9415 11.4804 21.558 12.1501 20.8809C12.7877 20.2361 13.1566 19.3753 13.1858 18.4723L19.0974 18.4394L19.0863 16.4394L17.4954 16.4482ZM11.1826 18.4834L8.01255 18.5011C8.0466 18.8729 8.21064 19.2225 8.47816 19.4871C8.77817 19.7838 9.18375 19.9491 9.60568 19.9468C10.0276 19.9444 10.4313 19.7746 10.728 19.4746C10.9926 19.207 11.1527 18.8556 11.1826 18.4834Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/Notif.34a3c5cd.svg";
export { ForwardRef as ReactComponent };